export default {
      id: "instagram-negative-usage",
      viewBox: "0 0 512 512",
      url: "/assets/svg/" + "sprite.svg#instagram-negative-usage",
      toString: function () {
        return this.url;
      }
    }